/** @format */

import { newRidgeState } from 'react-ridge-state'

export const GlobalValidationErrors = newRidgeState({})
